export { SystemInfoProvider, useSystemInfo } from './systemInfoContext';
